import { render, staticRenderFns } from "./actionAgentWithdrawalRequest.vue?vue&type=template&id=6572976d&"
import script from "./actionAgentWithdrawalRequest.vue?vue&type=script&lang=js&"
export * from "./actionAgentWithdrawalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports